<template>
  <div>
    <!-- :rules="mandatoryRule" -->
    <RadioGroup
      v-model="sessionReplica.replica_option"
      :options="options"
      :disabled="isRadioGroupDisable"
    />
  </div>
</template>

<script>
import { ref, inject, computed } from '@vue/composition-api';
import { isObjectEmpty, mandatoryRule } from '@/helpers/utils';
import RadioGroup from '@/components/common/RadioGroup.vue';

export default {
  components: { RadioGroup },
  setup () {
    const sessionReplica = inject('sessionReplica');

    const editable = inject('editable');
    const oldSessionDetail = inject('oldSessionDetail');

    const isRadioGroupDisable = computed(() => editable.value && (oldSessionDetail.value.replica && !isObjectEmpty(oldSessionDetail.value.replica)));

    const options = ref([
      { label: 'Tous les jours', value: 'ALL_JOURS' },
      { label: 'Toutes les semaines', value: 'ALL_WEEK' }
    ]);

    return { mandatoryRule, sessionReplica, options, editable, isRadioGroupDisable };
  }
};
</script>
